import "../styles/App.css";

import Navbar from "../components/Navbar/Navbar";
import Header from "../components/Header/Header";
import Footer from "../components/Footer/Footer";

import headerImg from "../assets/about-img.png";
import HeaderImgMobile from "../assets/about-img-mobile.png";
import DetailBox from "../components/DetailBox/DetailBox";

import aboutPageContents from "../data/aboutPageContent";
import { useEffect, useState } from "react";

function About() {
  document.title = "Kasa - A propos";

  const [bgImg, setBgImg] = useState(headerImg);

  const [matches, setMatches] = useState(
    window.matchMedia("(min-width: 768px)").matches
  );

  useEffect(() => {
    window
      .matchMedia("(min-width: 768px)")
      .addEventListener("change", (e) => setMatches(e.matches));
  }, []);

  useEffect(() => {
    if (matches) {
      setBgImg(headerImg);
    }
    if (!matches) {
      setBgImg(HeaderImgMobile);
    }
  }, [matches]);

  // const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  // function checkWindowSize(x) {
  //   console.log("inside");
  //   if (x <= 920) {
  //     setBgImg(HeaderImgMobile);
  //   } else {
  //     setBgImg(headerImg);
  //   }
  // }

  // function handleResize() {
  //   setWindowWidth(window.innerWidth);
  //   console.log(windowWidth);
  // }

  // useEffect(() => {
  //   console.log("caca prout");
  //   checkWindowSize(windowWidth);
  // }, [windowWidth]);
  // window.innerWidth.addEventListener("resize", () => {
  //   console.log("hello");
  // });

  // let mobileMediaQuery = window.matchMedia("(max-width: 920px)");
  // useEffect(checkWindowSize(mobileMediaQuery), [mobileMediaQuery]);
  // checkWindowSize(mobileMediaQuery);
  // useEffect(() => {
  //   console.log("hello");
  //   mobileMediaQuery.addEventListener("resize", checkWindowSize);
  // }, []);
  // window.addEventListener("resize", handleResize);

  return (
    <div className="About">
      <Navbar route="about" />
      <main>
        <Header
          imageSource={bgImg}
          // imageSource={
          //   window.matchMedia("(max-width: 920px)").matches
          //     ? headerImg
          //     : HeaderImgMobile
          // }
        />

        <section className="about">
          <div className="container container--about">
            {aboutPageContents.map((content) => {
              return (
                <DetailBox
                  key={content.key}
                  title={content.title}
                  content={content.content}
                />
              );
            })}
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}

export default About;
